import r from "../managers/braze-instance.js";
import tr from "./dust-provider.js";
const nr = {
  i: !1,
  provider: null,
  o: () => {
    if ((nr.t(), !nr.provider)) {
      const t = r.re("dustHost");
      (nr.provider = new tr(r.m(), r.p(), r.l(), t)),
        r.v(nr.provider),
        nr.provider.Hr();
    }
    return nr.provider;
  },
  t: () => {
    nr.i || (r.g(nr), (nr.i = !0));
  },
  destroy: () => {
    nr.provider && nr.provider.destroy(), (nr.provider = null), (nr.i = !1);
  },
};
export default nr;
